import React, { useState } from "react";
import { CONCESSIONARI, CUSTOM_BRAND } from "../config/concessionari";
import { CaretDown, Check } from "@phosphor-icons/react";

/**
 * Picker per il brand concessionario (SNAI, Sisal, Lottomatica, ecc.).
 *
 * Props:
 *  - value: string | null   (l'id selezionato, null = nessun brand / personalizzato)
 *  - onChange: (id) => void
 *  - className?: string
 *  - testId?: string
 */
export default function BrandPicker({ value, onChange, className = "", testId = "brand-picker" }) {
    const [open, setOpen] = useState(false);
    const selected =
        value && value !== "custom"
            ? CONCESSIONARI.find((c) => c.id === value)
            : null;

    const choose = (id) => {
        onChange(id);
        setOpen(false);
    };

    return (
        <div className={`relative ${className}`}>
            <button
                type="button"
                onClick={() => setOpen(!open)}
                className="inp w-full flex items-center justify-between gap-3 text-left"
                data-testid={testId}
            >
                <span className="flex items-center gap-3 min-w-0">
                    {selected ? (
                        <>
                            <img
                                src={selected.glyph || selected.logo}
                                alt={selected.name}
                                className="w-7 h-7 flex-shrink-0 object-contain"
                            />
                            <span className="font-bold truncate">{selected.name}</span>
                        </>
                    ) : (
                        <span className="text-zinc-500">{CUSTOM_BRAND.name}</span>
                    )}
                </span>
                <CaretDown size={12} weight="bold" className="flex-shrink-0 text-zinc-400" />
            </button>
            {open && (
                <>
                    <div
                        className="fixed inset-0 z-40"
                        onClick={() => setOpen(false)}
                        aria-hidden="true"
                    />
                    <div
                        className="absolute left-0 right-0 top-full mt-1 bg-white border border-zinc-200 z-50 shadow-md max-h-80 overflow-y-auto"
                        data-testid={`${testId}-list`}
                    >
                        <BrandRow
                            brand={CUSTOM_BRAND}
                            selected={!selected}
                            onClick={() => choose("custom")}
                            testId={`${testId}-opt-custom`}
                        />
                        <div className="border-t border-zinc-100" />
                        {CONCESSIONARI.map((c) => (
                            <BrandRow
                                key={c.id}
                                brand={c}
                                selected={selected?.id === c.id}
                                onClick={() => choose(c.id)}
                                testId={`${testId}-opt-${c.id}`}
                            />
                        ))}
                    </div>
                </>
            )}
        </div>
    );
}

function BrandRow({ brand, selected, onClick, testId }) {
    return (
        <button
            type="button"
            onClick={onClick}
            className={`w-full flex items-center gap-3 px-3 py-2.5 text-left hover:bg-zinc-50 ${selected ? "bg-zinc-100" : ""}`}
            data-testid={testId}
        >
            <div className="w-8 h-8 flex-shrink-0 flex items-center justify-center">
                {brand.glyph ? (
                    <img
                        src={brand.glyph}
                        alt={brand.name}
                        className="w-8 h-8 object-contain"
                    />
                ) : (
                    <span className="text-[9px] font-bold uppercase tracking-wider text-zinc-400">altro</span>
                )}
            </div>
            <span className="text-sm font-bold flex-1">{brand.name}</span>
            {selected && <Check size={14} weight="bold" />}
        </button>
    );
}
